module.exports = __webpack_public_path__ + "static/img/c4x2.502c08d8.png";